import {State} from './state.model';

export class StateListResult {
  error: boolean;
  errorMessage: string;
  errorMessageDetails: string;
  result: Array<State>;
}

export class MetadataStructureListResult {
  error: boolean;
  errorMessage: string;
  errorMessageDetails: string;
  result: Array<MetadataStructure>;
}

export class MetadataStructure {
  id: number;
  name: string;
  type: string;
  isDeleted: boolean;
  public toString = (): string => {
    return this.name;
  }
}
